import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const dataVersionsModule = namespace('dataVersions');
let Loading = class Loading extends Vue {
};
__decorate([
    dataVersionsModule.State
], Loading.prototype, "hasInternet", void 0);
Loading = __decorate([
    Component
], Loading);
export default Loading;
